import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import trackModalClosed from '@tracking/actions/trackModalClosed';
import trackModalOpened from '@tracking/actions/trackModalOpened';
import { getShopBusinessType } from '@shopDetails/selectors';
import navigateToVerticalResults from '@location/actions/navigateToVerticalResults';

import ErrorModalPreorderTimeFull from './ErrorModalPreorderTimeFull';

const mapStateToProps = createStructuredSelector({
  businessType: getShopBusinessType,
});

const mapDispatchToProps = {
  trackModalClosed,
  trackModalOpened,
  navigateToVerticalResults,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorModalPreorderTimeFull);
